import { render, staticRenderFns } from "./ProjectHeader.vue?vue&type=template&id=050eaca8&"
import script from "./ProjectHeader.vue?vue&type=script&lang=ts&"
export * from "./ProjectHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports